module.exports = __webpack_public_path__ + "img/testimonial_5.a7a0f923.png";